import { render, staticRenderFns } from "./ProductManagerBatchPopupIframe.vue?vue&type=template&id=64eb5d64&"
import script from "./ProductManagerBatchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductManagerBatchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports